import {createDescriptionObjectForList, createListFromObject} from "../../../components/common/commonUtilities";

export const GMS_CASE_NOTE_TYPE = {
    General:  createDescriptionObjectForList(1, "General")
};

export const GMS_CASE_NOTE_TYPE_LIST = createListFromObject(GMS_CASE_NOTE_TYPE);